import { render, staticRenderFns } from "./UserRecord.vue?vue&type=template&id=28e3ef70&scoped=true&"
import script from "./UserRecord.vue?vue&type=script&lang=js&"
export * from "./UserRecord.vue?vue&type=script&lang=js&"
import style0 from "./UserRecord.vue?vue&type=style&index=0&id=28e3ef70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3ef70",
  null
  
)

export default component.exports